import { Component, Input, OnInit } from '@angular/core';
import { SubheaderService } from 'src/app/core/_base/layout';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { NotificationsService } from 'angular2-notifications';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { LevelService } from 'src/app/services/level/level.service';
import { LevelModel } from 'src/app/models/afs/level.model';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';
import { PeriodService } from 'src/app/services/period/period.service';
import { Period } from '../../billet/models/period.model';
import { Subject } from 'rxjs';
import { FilterTableModel } from './model/filterTableModel';
import { MappingCurrentAccountBilletService } from './services/mappingCurrentAccountBillet.service';

export const Date_Only_Year = {
    parse: { dateInput: 'YYYY' },
    display: { dateInput: 'YYYY' },
};
export enum MappingType {
    Antigo = 0,
    Novo = 1,
}

@Component({
    selector: 'mappingCurrentAccountBillet-component',
    templateUrl: './mappingCurrentAccountBillet.component.html',
    styleUrls: [],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: Date_Only_Year },
    ],
})
export class MappingCurrentAccountBilletComponent implements OnInit {
    public yearSelected = new FormControl(moment());
    public levelSelected: any;
    public periodSelected: any;
    public levelList: LevelModel[] = [];
    public periodList: Period[] = [];
    public contractList: any[] = [];
    public isLoading = new Subject<boolean>();
    public filterTable: FilterTableModel = { description: '', fullName: '' };
    public checkEnum = { all: 0, onlyMapp: 1, notMapp: 2 };
    public checkSelected: number;
    public mappType: number;
    public subaccountSelected: number;
    public MappingType = MappingType;

    constructor(
        private _subheaderService: SubheaderService,
        private _translate: TranslateService,
        public _loaderService: LoaderService,
        public sessionBusiness: SessionBusiness,
        private notificationsService: NotificationsService,
        private levelService: LevelService,
        private periodService: PeriodService,
        private _mappingCurrentAccountBilletService: MappingCurrentAccountBilletService,
    ) {
        let title = this._translate.instant(`MENU.MappingCurrentAccountBillet`);
        _subheaderService.setTitle(`${title}`);
        this.levelSelected = { levelId: null };
        this.periodSelected = { periodId: null };
        this.contractList = [];
        this.mappType = MappingType.Novo;
        this.subaccountSelected = new Date().getFullYear();
    }

    ngOnInit() {
        this.getPeriod(this.sessionBusiness.EntityIdContext, new Date().getFullYear());
        this.checkSelected = this.checkEnum.notMapp;
    }

    onChangeRadio(item: number) {
        this.checkSelected = item;
    }

    searchAllEntities() {
        this.onClear();
        this.onSearch(true, false);
    }

    searchAllEntitiesChield() {
        this.onClear();
        this.onSearch(true, true);
    }

    chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.yearSelected.value;
        ctrlValue.year(normalizedYear.year());
        this.yearSelected.setValue(ctrlValue);
        this.getPeriod(this.sessionBusiness.EntityIdContext, this.yearSelected?.value?.year());
        datepicker.close();
    }

    clearResult() {
        this.contractList = [];
    }
    public onPeriodChange(periodId: string) {
        this.periodSelected.periodId = periodId;
        this.getLevel(periodId);
    }

    public onClear() {
        this.levelSelected = { levelId: null };
        this.periodSelected = { periodId: null };
        this.filterTable = { description: '', fullName: '' };
        this.clearResult();
    }

    public onLevelChange(levelId: string) {
        this.levelSelected.levelId = levelId;
    }

    private Load(value: boolean) {
        if (value) {
            this._loaderService.show();
        } else {
            this._loaderService.hide();
        }
        this.isLoading = this._loaderService.isLoading;
    }

    private getPeriod(entityId: string, subaccount: number): void {
        this.subaccountSelected = subaccount;
        this.Load(true);
        this.periodService
            .getByEntityIdAndSubAccount(entityId, subaccount.toString())
            .subscribe((result: CustomResponse<LevelModel>) => {
                this.Load(false);
                if (result.success) {
                    this.periodList = result.data;
                }
            });
    }

    private getLevel(periodId: string): void {
        this.Load(true);
        this.levelService.GetByPeriodId(periodId).subscribe((result: CustomResponse<LevelModel>) => {
            if (result.success) {
                this.levelList = result.data;
            }
            this.Load(false);
        });
    }
    public onSearch(all: boolean, allChield: boolean) {
        this.filterTable = { description: '', fullName: '' };
        const levelId = this.levelSelected?.levelId;
        const periodId = this.periodSelected?.periodId;

        this.Load(true);
        let entityId = this.sessionBusiness.EntityIdContext;
        let legalEntityId = this.sessionBusiness.LegalEntityIdContext;

        if (allChield) {
            entityId = null;
            all = false;
        } else if (all) {
            legalEntityId = null;
            entityId = null;
        }

        this._mappingCurrentAccountBilletService
            .GetContractsByParam(
                Boolean(this.mappType),
                levelId,
                periodId,
                this.checkSelected,
                entityId,
                legalEntityId,
                this.subaccountSelected,
            )
            .subscribe((result) => {
                if (result.success) {
                    this.contractList = result.data;
                    if (result.data == null || result.data.length == 0) {
                        this.notificationsService.warn('Nenhum dado encontrado');
                        this.Load(false);
                        return;
                    }
                }
                this.Load(false);
            });
    }
}
